import { RateSource } from "@redotech/money/rate-source";
import { zCurrency } from "@redotech/money/usd-amounts";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

const rateSchema_ = z.object({
  source: createEnum(RateSource),
  base: zCurrency,
  quote: zCurrency,
  rate: z.number(),
  asOf: z.number().int(),
});

/** `rate` units of `quote` per 1 `base`, as of `asOf` (epoch ms). */
export interface Rate extends z.infer<typeof rateSchema_> {}

export const RateSchema: z.ZodType<Rate> = rateSchema_;

export type RateRef = Pick<Rate, "source" | "base" | "quote">;
